import { QuoteCard, extractQuoteCardAttributes } from "tm/quoteCard";
import { ChildrenElement } from "tm/utils";

export default class extends ChildrenElement<QuoteCard> {
  private get grid(): QuoteCard[] {
    return this.isEvenChildren()
      ? this.items
      : [{ ...this.items[0], size: "hero" }, ...this.items.slice(1)];
  }

  private get className() {
    return this.isEvenChildren() ? "quotes-a" : "quotes-a featured";
  }

  private isEvenChildren() {
    return this.items.length % 2 === 0;
  }

  childTagName = "TM-QUOTE";
  extractor = extractQuoteCardAttributes;
}
